<template>
  <div class="mb-8 border rounded-lg bg-white p-4">
    <div class="flex flex-wrap items-start justify-between gap-3">
      <div>
        <h3 class="text-lg font-semibold leading-tight">PDF report packs</h3>
        <div class="text-xs text-gray-500 mt-1">Designed for internal stakeholders who need the story, not the raw data.</div>
      </div>
      <button
        type="button"
        class="px-3 py-2 rounded text-xs border border-black bg-black text-white disabled:opacity-50 disabled:cursor-not-allowed"
        :disabled="state.surveyReportLoading || !state.surveyStats"
        @click="actions.downloadSurveyReport()"
      >
        {{ state.surveyReportLoading ? 'Generating...' : 'Download PDF' }}
      </button>
    </div>

    <div class="mt-4">
      <div class="text-sm font-semibold mb-2">Who is this for?</div>
      <div class="grid grid-cols-1 md:grid-cols-5 gap-2" role="tablist" aria-label="Survey report pack">
        <button
          v-for="pack in reportPacks"
          :key="pack.key"
          type="button"
          :class="packButtonClass(pack.key)"
          role="tab"
          :aria-selected="state.surveyReportPack === pack.key"
          @click="$emit('update:surveyReportPack', pack.key)"
        >
          <span class="block font-semibold">{{ pack.label }}</span>
          <span class="block text-xs mt-1 opacity-80">{{ pack.caption }}</span>
        </button>
      </div>
    </div>

    <div class="mt-4 border-t pt-4 grid grid-cols-1 md:grid-cols-4 gap-3">
      <div class="rounded border bg-gray-50 p-3">
        <div class="text-xs text-gray-500">Registrations</div>
        <div class="text-xl font-semibold">{{ state.surveyStats.total_registrations || 0 }}</div>
      </div>
      <div class="rounded border bg-gray-50 p-3">
        <div class="text-xs text-gray-500">Registrations with answers</div>
        <div class="text-xl font-semibold">{{ state.surveyStats.responders || 0 }}</div>
      </div>
      <div class="rounded border bg-gray-50 p-3">
        <div class="text-xs text-gray-500">Answer coverage</div>
        <div class="text-xl font-semibold">{{ state.surveyStats.response_rate_pct || 0 }}%</div>
      </div>
      <div class="rounded border bg-gray-50 p-3">
        <div class="text-xs text-gray-500">Questions</div>
        <div class="text-xl font-semibold">{{ (state.surveyStats.questions || []).length }}</div>
      </div>
    </div>

    <div class="mt-4 text-xs text-gray-600">
      Includes an executive summary, response-health visuals, top answer distributions, and recommended actions tailored to the selected department.
    </div>
    <div v-if="state.surveyReportError" class="mt-3 text-sm text-red-600">{{ state.surveyReportError }}</div>
  </div>
</template>

<script>
export default {
  name: 'SurveyReportsSection',
  props: {
    state: { type: Object, required: true },
    actions: { type: Object, required: true },
  },
  data() {
    return {
      reportPacks: [
        { key: 'executive', label: 'Executive', caption: 'Budget story' },
        { key: 'careers', label: 'Careers', caption: 'Support demand' },
        { key: 'alumni', label: 'Alumni', caption: 'Opt-in signals' },
        { key: 'marketing', label: 'Marketing', caption: 'Student voice' },
        { key: 'graduation', label: 'Graduation', caption: 'Ops gaps' },
      ],
    }
  },
  methods: {
    packButtonClass(key) {
      const base = 'text-left border rounded p-3 focus:outline-none focus:ring-2 focus:ring-black'
      if (this.state.surveyReportPack === key) return `${base} border-black bg-black text-white`
      return `${base} bg-white hover:bg-gray-50`
    },
  },
}
</script>
